export const calculateTotalCostTrend = (
  totalCost: number,
  prevPeriodTotalCost: number,
): number => {
  return ((totalCost - prevPeriodTotalCost) / prevPeriodTotalCost) * 100;
};
